import { mongoDBRequest } from "../services/api/dbRequest";
import throwMessage from "../utils/throwMessage";
import { invalidateUserCache } from "./dataCache";

export const DataFetcher = async (url_screen, payload) => {
  const invalidateCache = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?._id) {
        await invalidateUserCache(user._id);
      }
    } catch (error) {
      console.error("Cache invalidation error:", error);
    }
  };

  // get functions
  const getAllTrades = async () => {
    return await mongoDBRequest("all-trades", "GET")
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "get-all-trades");
      });
  };

  // post functions
  // ----- results-tracker -----
  const postNewTrade = async () => {
    return await mongoDBRequest("new-trade-entry", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "get-all-backtests");
      });
  };
  const postSingleTrade = async () => {
    return await mongoDBRequest("single-trade", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-single-trade");
      });
  };
  const postGenerateTrades = async () => {
    return await mongoDBRequest("generate-trades", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-generate-trades");
      });
  };

  // ----- calendar -----
  const postSingleReflection = async () => {
    return await mongoDBRequest("single-reflection", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-single-reflection");
      });
  };
  const postNewReflection = async () => {
    return await mongoDBRequest("new-reflection", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-new-reflection");
      });
  };
  const postTradesToReflect = async () => {
    return await mongoDBRequest("get-trades-to-reflect", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-get-trades-to-reflect");
      });
  };
  const postTradesToReflectHistoric = async () => {
    return await mongoDBRequest(
      "get-trades-to-reflect-historic",
      "POST",
      payload
    )
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-get-trades-to-reflect-historic");
      });
  };
  const deleteReflection = async () => {
    return await mongoDBRequest("delete-reflection", "DELETE", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "delete-reflection");
      });
  };
  const postEditReflection = async () => {
    return await mongoDBRequest("edit-reflection", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-edit-reflection");
      });
  };
  const postNewJournal = async () => {
    return await mongoDBRequest("new-journal", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-new-journal");
      });
  };
  const postAllJournal = async () => {
    return await mongoDBRequest("all-journal", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-all-journal");
      });
  };
  const postGetSingleJournal = async () => {
    return await mongoDBRequest("get-single-journal", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-get-single-journal");
      });
  };
  const postEditJournal = async () => {
    return await mongoDBRequest("edit-journal", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-edit-journal");
      });
  };
  const postGenerateJournalShareToken = async () => {
    return await mongoDBRequest("generate-journal-share-token", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "Failed to generate share link");
      });
  };
  const postNewForecast = async () => {
    return await mongoDBRequest("new-forecast", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-new-forecast");
      });
  };
  const postEditForecast = async () => {
    return await mongoDBRequest("edit-forecast", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-edit-forecast");
      });
  };
  const postSingleForecast = async () => {
    return await mongoDBRequest("single-forecast", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-single-forecast");
      });
  };
  const postNewBacktest = async () => {
    return await mongoDBRequest("new-backtest", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-new-backtest");
      });
  };
  // put functions
  // ----- results-tracker -----
  const putEditTrade = async () => {
    return await mongoDBRequest("edit-trade", "PUT", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", " get-all-backtests");
      });
  };

  const putEditBacktest = async () => {
    return await mongoDBRequest("edit-backtest", "PUT", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "edit-backtest");
      });
  };
  // ----- calendar -----
  // delete functions

  // ----- results-tracker -----
  const deleteTrade = async () => {
    return await mongoDBRequest("remove-trade", "DELETE", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "delete-remove-trade");
      });
  };
  const deleteForecast = async () => {
    return await mongoDBRequest("delete-forecast", "DELETE", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "delete-delete-forecast");
      });
  };
  const deleteBacktest = async () => {
    return await mongoDBRequest("remove-backtest", "DELETE", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "delete-remove-backtest");
      });
  };
  // ----- calendar -----

  // auth

  // post
  const postNewTransaction = async () => {
    return await mongoDBRequest("new-transaction", "POST", payload)
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "post-new-transaction");
      });
  };

  const cleanupOldCalendarCaches = async () => {
    return await mongoDBRequest("cleanup-calendar-cache", "DELETE")
      .then(async (data) => {
        return data;
      })
      .catch((err) => {
        throwMessage("error", "cleanup-calendar-cache");
      });
  };

  switch (url_screen) {
    // ------------ Screens ----------------- //
    case "run-all":
      try {
        return await mongoDBRequest("user-data", "GET");
      } catch (error) {
        throwMessage("error", "Failed to load user data");
        return;
      }

    case 0:
      try {
        const database_dump_screen_one = {
          // trades: await getAllTrades(),
          // reflections: await getAllReflections(),
          // forecasts: await getAllForecasts(),
          // forecastsBacktesting: await getAllForecastsBacktesting(),
          // journals: await getAllJournals(),
          // backtests: await getAllBacktests(),
        };
        return database_dump_screen_one;
      } catch (error) {
        return;
      }

    case 1:
      try {
        // limit these calls to 50 records ??
        const database_dump_screen_two = {
          // trades: await getAllTrades(),
          // journals: await getAllJournals(),
          // backtests: await getAllBacktests(),
          // forecasts: await getAllForecasts(),
        };
        return database_dump_screen_two;
      } catch (error) {
        return;
      }
    // ------------ Results Tracker ----------------- //
    case "all-trades":
      try {
        return await getAllTrades();
      } catch (error) {
        return;
      }
    case "new-trade-entry":
      try {
        const result = await postNewTrade();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "single-trade":
      try {
        return await postSingleTrade();
      } catch (error) {
        return;
      }
    case "generate-trades":
      try {
        return await postGenerateTrades();
      } catch (error) {
        return;
      }
    case "edit-trade":
      try {
        const result = await putEditTrade();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    // case "mass-edit-trade":
    //   try {
    //     return await putMassEditTrade();
    //   } catch (error) {
    //     return;
    //   }
    case "remove-trade":
      try {
        const result = await deleteTrade();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }

    case "new-backtest":
      try {
        const result = await postNewBacktest();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "edit-backtest":
      try {
        const result = await putEditBacktest();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "remove-backtest":
      try {
        const result = await deleteBacktest();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }

    // ------------ Calendar ----------------- //

    case "get-trades-to-reflect":
      try {
        return await postTradesToReflect();
      } catch (error) {
        return;
      }
    case "get-trades-to-reflect-historic":
      try {
        return await postTradesToReflectHistoric();
      } catch (error) {
        return;
      }

    case "new-reflection":
      try {
        const result = await postNewReflection();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "single-reflection":
      try {
        return await postSingleReflection();
      } catch (error) {
        return;
      }

    case "edit-reflection":
      try {
        const result = await postEditReflection();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }

    case "delete-reflection":
      try {
        const result = await deleteReflection();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }

    case "generate-reflection-share-token":
      try {
        return await mongoDBRequest("generate-reflection-share-token", "POST", payload)
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to generate share link");
          });
      } catch (error) {
        return;
      }

    case "new-journal":
      try {
        const result = await postNewJournal();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "all-journal":
      try {
        return await postAllJournal();
      } catch (error) {
        return;
      }

    case "get-single-journal":
      try {
        return await postGetSingleJournal();
      } catch (error) {
        return;
      }
    case "edit-journal":
      try {
        const result = await postEditJournal();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "generate-journal-share-token":
      try {
        return await postGenerateJournalShareToken();
      } catch (error) {
        return;
      }

    case "single-forecast":
      try {
        return await postSingleForecast();
      } catch (error) {
        return;
      }
    case "edit-forecast":
      try {
        const result = await postEditForecast();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "new-forecast":
      try {
        const result = await postNewForecast();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "delete-forecast":
      try {
        const result = await deleteForecast();
        await invalidateCache();
        return result;
      } catch (error) {
        return;
      }
    case "generate-share-token":
      try {
        return await mongoDBRequest("generate-share-token", "POST", payload)
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to generate share token");
          });
      } catch (error) {
        return;
      }

    case "new-transaction":
      try {
        return await postNewTransaction();
      } catch (error) {
        return;
      }

    
    // ------------ Trade Slots ----------------- //

    case "save-trade-slot":
      try {
        return await mongoDBRequest("save-trade-slot", "POST", payload)
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to save trade slot");
          });
      } catch (error) {
        return;
      }
    case "get-trade-slots":
      try {
        return await mongoDBRequest("get-trade-slots", "POST", payload)
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to fetch trade slots");
          });
      } catch (error) {
        return;
      }
    case "delete-trade-slot":
      try {
        return await mongoDBRequest("delete-trade-slot", "POST", payload)
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to delete trade slot");
          });
      } catch (error) {
        return;
      }

    case "recent-unique-trades":
      try {
        return await mongoDBRequest("recent-unique-trades", "GET")
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to fetch recent trades");
          });
      } catch (error) {
        return;
      }

    case "get-trade-by-id":
      try {
        return await mongoDBRequest("get-trade-by-id", "GET", payload)
          .then(async (data) => {
            return data;
          })
          .catch((err) => {
            throwMessage("error", "Failed to fetch trade by ID");
          });
      } catch (error) {
        return;
      }

    case "cleanup-calendar-cache":
      try {
        return await cleanupOldCalendarCaches();
      } catch (error) {
        return;
      }

    default:
      break;
  }
};
